var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-button',_vm._g(_vm._b({attrs:{"icon":_vm.icon,"label":_vm.buttonLabel,"type":"danger"}},'default-button',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }